import React, { useState } from 'react';
import SgsstCrudPage from '../components/SgsstCrudPage';
import SgsstTabs from '../components/SgsstTabs';
import { S } from '../components/sgsstUi';
import { sgsstBrigadistas, sgsstSimulacros } from '../services/api';

const hoy = () => new Date().toISOString().slice(0, 10);
const ROL = { jefe: 'Jefe de brigada', primeros_auxilios: 'Primeros auxilios', evacuacion: 'Evacuación', contra_incendios: 'Contra incendios' };
const SIM = { evacuacion: 'Evacuación', incendio: 'Incendio', sismo: 'Sismo', medico: 'Médico', otro: 'Otro' };

export default function SgsstBrigadas() {
  const [sub, setSub] = useState('brigadistas');
  return (
    <div style={S.wrap}>
      <SgsstTabs />
      <div style={{ display: 'flex', gap: 4, marginBottom: 12 }}>
        {[['brigadistas', 'Brigadistas'], ['simulacros', 'Simulacros']].map(([k, l]) =>
          <button key={k} onClick={() => setSub(k)} style={{ ...b, ...(sub === k ? bOn : {}) }}>{l}</button>)}
      </div>
      {sub === 'brigadistas' ? (
        <SgsstCrudPage hideTabs title="Brigadistas" newLabel="+ Nuevo brigadista" api={sgsstBrigadistas}
          vacio={{ nombre: '', rol: 'evacuacion', telefono: '', capacitado: false, vigencia_capacitacion: '' }}
          columns={[{ k: 'nombre', h: 'Nombre', strong: true }, { k: 'rol', h: 'Rol', map: ROL }, { k: 'telefono', h: 'Teléfono' }, { k: 'capacitado', h: 'Capacitado', fmt: 'bool' }, { k: 'vigencia_capacitacion', h: 'Vigencia', fmt: 'date' }]}
          fields={[{ k: 'nombre', l: 'Nombre', type: 'text', full: true }, { k: 'rol', l: 'Rol', type: 'select', opts: Object.entries(ROL) }, { k: 'telefono', l: 'Teléfono', type: 'text' }, { k: 'capacitado', l: '¿Capacitado?', type: 'bool' }, { k: 'vigencia_capacitacion', l: 'Vigencia capacitación', type: 'date' }]}
        />
      ) : (
        <SgsstCrudPage hideTabs title="Simulacros" newLabel="+ Nuevo simulacro" api={sgsstSimulacros}
          vacio={{ fecha: hoy(), tipo: 'evacuacion', participantes: 0, duracion_min: 0, hallazgos: '', mejoras: '' }}
          columns={[{ k: 'fecha', h: 'Fecha', fmt: 'date' }, { k: 'tipo', h: 'Tipo', map: SIM, strong: true }, { k: 'participantes', h: 'Participantes', mono: true }, { k: 'duracion_min', h: 'Duración (min)', mono: true }]}
          fields={[{ k: 'fecha', l: 'Fecha', type: 'date' }, { k: 'tipo', l: 'Tipo', type: 'select', opts: Object.entries(SIM) }, { k: 'participantes', l: 'Participantes', type: 'number' }, { k: 'duracion_min', l: 'Duración (min)', type: 'number' }, { k: 'hallazgos', l: 'Hallazgos', type: 'textarea', full: true }, { k: 'mejoras', l: 'Acciones de mejora', type: 'textarea', full: true }]}
        />
      )}
    </div>
  );
}
const b = { padding: '7px 14px', borderRadius: 8, border: '1px solid #334155', background: 'transparent', color: '#94a3b8', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
const bOn = { background: '#1e293b', color: '#f1f5f9', borderColor: '#f59e0b' };
